export const SYSTEM_USER = 'system';
// Stencil PageHeader component has a fixed height of 64px hence using this as a constant
export const HEADER_HEIGHT = 72;
export const INSIDE_AMAZON_DOMAIN_NAME = 'https://inside.hr.amazon.dev/';
export const INSIDE_AMAZON_HTML_POLICY_SUFFIX = '.html';
